import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import api from '~/services/api';

export default function RestoreUserModal({
  show,
  setShow,
  user,
  setData,
  users,
  // setFilter,
  setUserToBeRestored,
  params,
}) {
  const roles = useSelector(({ user: User }) => User.profile.roles);

  const isStoreManager = useMemo(
    () => roles.find(role => role.slug === 'store-manager'),
    [roles]
  );

  const isAdmin = useMemo(
    () => roles.find(role => role.slug === 'administrator'),
    [roles]
  );

  const handleRestoreUser = async id => {
    try {
      await api.patch(
        `${
          isStoreManager && !isAdmin ? 'store-manager' : 'administrator'
        }/users/${id}/restore`
      );

      const { data } = await api.get(
        `${
          isStoreManager && !isAdmin ? 'store-manager' : 'administrator'
        }/users`,
        {
          params: {
            ...params,

            page: users.length === 1 ? params.page - 1 : params.page,
          },
        }
      );

      setData(data);
      // setFilter(false);
      setShow(false);

      toast.success('Usuário reativado com sucesso!');
    } catch (err) {
      if (err.response && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message, {
          autoClose: err?.response?.data?.duration || 5000,
        });
      } else {
        toast.error(err.message);
      }
    }
  };

  const toggle = () => {
    setUserToBeRestored(null);
    setShow(false);
  };

  return (
    <Modal isOpen={show}>
      <ModalHeader toggle={toggle}>Deseja reativar o usuário?</ModalHeader>
      <ModalBody>
        <h5>
          O usuário <strong>{user?.name}</strong> será reativado.
        </h5>
      </ModalBody>
      <ModalFooter>
        <Button
          className="new-layout-btn main"
          color="success"
          size="lg"
          onClick={() => handleRestoreUser(user?.id)}
        >
          Reativar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
